(function () {
  function init(root) {
    if (!root || root.getAttribute("data-hero-ready") === "true") return;
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    if (slides.length < 2) return;
    root.setAttribute("data-hero-ready", "true");

    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hero-dot]"));
    var prev = root.querySelector("[data-hero-prev]");
    var next = root.querySelector("[data-hero-next]");
    var interval = parseInt(root.getAttribute("data-interval"), 10) || 6000;
    var autoplay = root.getAttribute("data-autoplay") === "true";
    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(nextIndex) {
      if (nextIndex === index) return;
      slides[index].classList.remove("is-active");
      slides[index].setAttribute("aria-hidden", "true");
      if (dots[index]) {
        dots[index].classList.remove("is-active");
        dots[index].removeAttribute("aria-current");
      }
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add("is-active");
      slides[index].removeAttribute("aria-hidden");
      if (dots[index]) {
        dots[index].classList.add("is-active");
        dots[index].setAttribute("aria-current", "true");
      }
    }

    function play() {
      if (!autoplay || reduceMotion) return;
      stop();
      timer = window.setInterval(function () {
        show(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) {
      prev.addEventListener("click", function () {
        show(index - 1);
        play();
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        show(index + 1);
        play();
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        show(i);
        play();
      });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", play);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else play();
    });

    play();
  }

  function start() {
    document.querySelectorAll("[data-hero-slider]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-hero-slider]") || event.target;
    if (root && root.hasAttribute && root.hasAttribute("data-hero-slider")) init(root);
  });
})();
